exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SharingOptions__sharingButton___1uByp {\n  color: #404040;\n  cursor: pointer;\n  display: flex;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: 0.02em;\n  align-items: center;\n  transition: 300ms; }\n  .SharingOptions__sharingButton___1uByp .SharingOptions__icon___3CiQV {\n    margin-right: 8px;\n    font-size: 17px;\n    vertical-align: middle;\n    transition: 300ms; }\n  .SharingOptions__sharingButton___1uByp:hover {\n    color: #f94144; }\n    .SharingOptions__sharingButton___1uByp:hover .SharingOptions__icon___3CiQV {\n      color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"sharingButton": "SharingOptions__sharingButton___1uByp",
	"icon": "SharingOptions__icon___3CiQV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SharingOptions/styles/SharingOptions.scss
// module id = 4594
// module chunks = 6